module.exports = __webpack_public_path__ + "img/akash-small-dark.ad1e82b3.svg";